















import Vue from "vue";
import iwInputToggle from "../../buildingBlocks/InputToggle.vue";

export default Vue.extend({
    components: {
        iwInputToggle: iwInputToggle,
    },
    data: function() {
        return {
            previewType: "DESKTOP"
        };
    },
    methods: {
        handleClick: function() {
            (this.$refs.inputToggle as Vue & { actionClick: () => void }).actionClick();
        },
        updateTransactionType: function(value: string) {
            this.$emit("update-preview-type", value);
        },
    }
});

